import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`;

export const Content = styled.div`
  flex-grow: 1;
  height: 100%;
  overflow: auto;
`;
